var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ dropping: _vm.isDropping },attrs:{"id":"drop-area"}},[_c('div',{directives:[{name:"t",rawName:"v-t",value:('label.drop-area'),expression:"'label.drop-area'"}],staticClass:"message"})])}
var staticRenderFns = []

export { render, staticRenderFns }